export default __webpack_public_path__ + "media/zurb/img/about/about-img1-687c86c422f4aa75b7e994dcb36fe722.png";